import React, { useEffect } from "react";
import HeaderLogo from "../../../components/header/headerLogo";
import "../../../assets/scss/account/register.scss";
import { Link } from "react-router-dom";
import verified from "../../../assets/images/verified.png";
import Repository from "../../../configs/axios/repository";

const Verify = (props) => {
    // const myArray = props.location.pathname.split("/verify/");
    // const verifyCode = myArray[1];
    const queryParameters = new URLSearchParams(window.location.search);
    const verifyCode = queryParameters?.get("verifyCode");
    const course_id = queryParameters?.get("course_id");
    const courseName = queryParameters?.get("course_name");
    const emailNotDecoding = queryParameters.get("email");
    const email = decodeURIComponent(queryParameters?.get("email"))?.replace(
        / /g,
        "+"
    );
    const makeVerified = async () => {
        const result = await Repository.postRequest(`api/users/makeVerified`, {
            code: Number(verifyCode),
        });
        if (result.data.success) {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key.startsWith("tour-")) {
                    localStorage.removeItem(key);
                }
            }

            localStorage.setItem("firstLogin", true);
        }
    };

    useEffect(() => {
        makeVerified();
    }, []);

    return (
        <div className="verify ">
            <div className="headerParent">
                <HeaderLogo />
            </div>
            <div className="minHeight d-flex  justify-content-md-center">
                <div className="d-block mt-5 mb-1 verifyContent">
                    <div>
                        <img
                            className="rounded mx-auto d-block"
                            src={verified}
                        />
                    </div>
                    <h1 className="text-center">VERIFIED!</h1>

                    <h6 className="verified text-center">
                        You have successfully verified your email
                    </h6>
                    <div className="regSubmit">
                        {course_id != undefined ? (
                            <Link
                                to={{
                                    pathname: "/login",
                                    search: emailNotDecoding
                                        ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
                                        : `course_id=${course_id}&course_name=${courseName}`,
                                }}
                            >
                                <button
                                    className="verifyEmail rounded mx-auto d-block"
                                    type="submit"
                                >
                                    Login
                                </button>
                            </Link>
                        ) : (
                            <Link to="/login">
                                <button
                                    className="verifyEmail rounded mx-auto d-block"
                                    type="submit"
                                >
                                    Login
                                </button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Verify;
